import React from 'react';
import Statistic from './components/statistic';
import OrderChart from './components/orderChart';
import DashboardOrder from './components/order';

const Dashboard: React.FC = () => {
  return (
    <div className="flex flex-col gap-2">
      <DashboardOrder />
      <Statistic />
      <OrderChart />
    </div>
  );
};

export default Dashboard;
